"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.coordinatesToCanvasPosition = exports.mapLatLngToCoordinates = exports.mapCoordinatesToLatLng = exports.mapCoordinatesToLatLngLiteral = void 0;
function mapCoordinatesToLatLngLiteral(coordinates) {
    return {
        lat: coordinates.latitude,
        lng: coordinates.longitude,
    };
}
exports.mapCoordinatesToLatLngLiteral = mapCoordinatesToLatLngLiteral;
function mapCoordinatesToLatLng(coordinates) {
    return new google.maps.LatLng(mapCoordinatesToLatLngLiteral(coordinates));
}
exports.mapCoordinatesToLatLng = mapCoordinatesToLatLng;
function mapLatLngToCoordinates({ lng, lat, }) {
    return {
        longitude: typeof lng === 'function' ? lng() : lng,
        latitude: typeof lat === 'function' ? lat() : lat,
    };
}
exports.mapLatLngToCoordinates = mapLatLngToCoordinates;
function pointToPosition({ x, y, }) {
    return {
        left: `${x}px`,
        top: `${y}px`,
    };
}
function coordinatesToCanvasPosition(projection, coordinates) {
    return pointToPosition(projection.fromLatLngToDivPixel(mapCoordinatesToLatLng(coordinates)));
}
exports.coordinatesToCanvasPosition = coordinatesToCanvasPosition;
//# sourceMappingURL=Map.mappers.js.map